import { PeopleContractTypeDto } from '../people-contract-type.dto';
import { PeoplePayFrequencyDto } from '../people-pay-frequency.dto';
import { PeoplePayTypeDto } from '../people-pay-type.dto';
import { PeopleEmployeeDto } from './people-employee.dto';
export class PeopleEmployeeContractDto {
  id?: number;
  employeeId?: number;
  contractTypeId?: number;
  contractIssueDate?: Date;
  contractEndDate?: Date;
  payTypeId?: number;
  payFrequencyId?: number;
  payRate?: number;
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;

  employee?: PeopleEmployeeDto;
  contractType?: PeopleContractTypeDto;
  payType?: PeoplePayTypeDto;
  payFrequency?: PeoplePayFrequencyDto;
}
